var map = {
	"./global/DarkModeSwitcher.vue": "3efc",
	"./global/LangSwitcher.vue": "a0bf",
	"./global/Logo.vue": "0c57",
	"./global/SelectCustom.vue": "428e",
	"./pages/HomePage.vue": "391e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "73f7";